import { AlertOutlineIcon } from '@atgfr8/icons';
export const TruckerToolsCaution = () => {
  return (
    <div class="w-full rounded-lg px-2 py-1 border-solid border-caution-yellow border-2 bg-caution-yellow font-roboto text-sm ">
      <div class="flex items-center gap-x-2">
        <AlertOutlineIcon class="text-caution-yellow!" />
        <div class="flex flex-col w-full">
          Updating tracking values will automatically update the corresponding
          driver details within the load.
        </div>
      </div>
    </div>
  );
};
